import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

type Props = PropsWithChildren<{
    dataAutomation: string;
    title: string;
    description: string;
}>;

const SectionTitleContainer = ({ dataAutomation, title, description, children }: Props) => {
    return (
        <Stack
            data-automation={dataAutomation}
            gap="8px"
        >
            <Flex
                gap="6px"
                alignItems="center"
            >
                <Text
                    fontVariant="h5"
                    data-automation="title-text"
                    color={colorsPalettes.carbon[500]}
                >
                    {title}
                </Text>

                {children}
            </Flex>

            <Text
                fontVariant="body2"
                data-automation="description-text"
                color={colorsPalettes.carbon[400]}
            >
                {description}
            </Text>
        </Stack>
    );
};

export default SectionTitleContainer;
